import { t } from "@travily/i18n";
import familyIllustration from "@ui/assets/illustrations/family-animated.webp";
import { Wizard } from "@ui/components/Wizard";
import { WizardTextArea } from "@ui/components/WizardTextArea";
import type { ReactNode } from "react";

const COLOR = "red" as const;

export interface FamilyConnectStepViewProps {
  /** Wizard progress: 1-based index of the current stage. */
  currentStage: number;
  /** Wizard progress: total number of stages. */
  totalStages: number;
  /** Navigate to the previous stage. Omit to hide the back button. */
  onBack?: () => void;
  /** Top-bar tertiary actions (e.g. "Questions?", "Save and finish later"). */
  topBarActions: ReactNode;
  /** Advance to / submit the current stage. */
  onPrimary: () => void;
  /** Whether the primary button shows a pending spinner. */
  primaryPending: boolean;
  /** Field error for the socials input, or undefined when valid. */
  error?: string;
  /** Current value of the socials textarea. */
  socials: string;
  /** Called with the new value on every textarea change. */
  onSocialsChange: (value: string) => void;
}

export function FamilyConnectStepView({
  currentStage,
  totalStages,
  onBack,
  topBarActions,
  onPrimary,
  primaryPending,
  error,
  socials,
  onSocialsChange,
}: FamilyConnectStepViewProps) {
  return (
    <Wizard color={COLOR} currentStage={currentStage} totalStages={totalStages} onBack={onBack}>
      {topBarActions}
      <Wizard.PrimaryButton onPress={onPrimary} isPending={primaryPending}>
        {t("common.actions.continue")}
      </Wizard.PrimaryButton>
      <Wizard.Stage
        illustration={<img alt="" aria-hidden="true" src={familyIllustration} />}
        heading={t("web.founding_members.creator.steps.family.connect.show.title")}
      >
        <div className="w-full max-w-[600px]">
          <WizardTextArea
            color={COLOR}
            errorMessage={error}
            isInvalid={Boolean(error)}
            isLabelHidden
            label={t("web.founding_members.creator.steps.family.connect.show.label")}
            onChange={onSocialsChange}
            placeholder={t("web.founding_members.creator.steps.family.connect.show.placeholder")}
            rows={4}
            value={socials}
          />
        </div>
      </Wizard.Stage>
    </Wizard>
  );
}
